module.exports = __webpack_public_path__ + "static/media/EasterSunday.498c3b9a.jpg";